// extracted by mini-css-extract-plugin
export default {"wrapper":"SurveyLetterForm_wrapper__sVPFO"};